// extracted by mini-css-extract-plugin
export default {"layout":"PageLayout_layout_Fb1MU","content":"PageLayout_content_GG5H6"};